import React, { useEffect, useState, useMemo } from 'react';
import connect from 'react-redux/lib/connect/connect';
import { fixedNumber, getMarketDetail, isEmpty } from '../../common/cores';

const bettingStyle = { transition: "all 300ms", overflow: 'hidden', cursor: "pointer" };

const BetItem = (props) => {
  const { item, itemIndex, betList, originSportslist, onBetItem, checkBetted, interiorShowMarket } = props;

  const { baselineSetting, pageInfo } = props;
  const { sportPrematchRateSetting, sportLiveRateSetting, esportPrematchRateSetting, esportLiveRateSetting } = baselineSetting;

  const rateValue = useMemo(() => {
    const sportId = originSportslist.Fixture.League.sport.Id;
    let sportsRateIndex = -1;
    let sportRate = {}
    if (pageInfo.RoomType === "sport") {
      if (pageInfo.gameType === "live") {
        sportsRateIndex = isEmpty(sportLiveRateSetting) ? -1 : sportLiveRateSetting.findIndex(setting => setting.sportId == sportId);
        sportRate = sportsRateIndex > -1 ? sportLiveRateSetting[sportsRateIndex] : {};
      }
      else {
        sportsRateIndex = isEmpty(sportPrematchRateSetting) ? -1 : sportPrematchRateSetting.findIndex(setting => setting.sportId == sportId);
        sportRate = sportsRateIndex > -1 ? sportPrematchRateSetting[sportsRateIndex] : {};
      }


      if (!isEmpty(sportRate) && sportRate.status && !isEmpty(sportRate.min) && !isEmpty(sportRate.max)) {
        return {
          min: Number(sportRate.min),
          max: Number(sportRate.max),
        }
      }
      else {
        return {}
      }
    }
    else {
      if (pageInfo.gameType === "live") {
        sportsRateIndex = isEmpty(esportLiveRateSetting) ? -1 : esportLiveRateSetting.findIndex(setting => setting.sportId == sportId);
        sportRate = sportsRateIndex > -1 ? esportLiveRateSetting[sportsRateIndex] : {};
      }
      else {
        sportsRateIndex = isEmpty(esportPrematchRateSetting) ? -1 : esportPrematchRateSetting.findIndex(setting => setting.sportId == sportId);
        sportRate = sportsRateIndex > -1 ? esportPrematchRateSetting[sportsRateIndex] : {};
      }


      if (!isEmpty(sportRate) && sportRate.status && !isEmpty(sportRate.min) && !isEmpty(sportRate.max)) {
        return {
          min: Number(sportRate.min),
          max: Number(sportRate.max),
        }
      }
      else {
        return {}
      }
    }
  }, [pageInfo.gameType, sportPrematchRateSetting, sportLiveRateSetting, esportPrematchRateSetting, esportLiveRateSetting]);

  const [nowRate, setNowRate] = useState(item.Price[0].Price);

  const setTimeRate = () => {
    setTimeout(() => {
      setNowRate(item.Price[0].Price);
    }, 4600)
  }
  useEffect(() => {
    if (nowRate !== item.Price[0].Price) {
      setTimeRate();
    }
  }, [item])

  useEffect(() => {
    return () => {
      clearTimeout(setTimeRate());
    }
  }, [])

  let minRate = 1;
  let maxRate = 10;
  if (pageInfo.gameType === "live") {
    if (pageInfo.sportType === "esport") {
      minRate = !isEmpty(baselineSetting.eliveminrate) ? baselineSetting.eliveminrate : 1
      maxRate = !isEmpty(baselineSetting.eliveminrate) ? baselineSetting.elivemaxrate : 1
    }
    else {
      minRate = !isEmpty(baselineSetting.liveminrate) ? baselineSetting.liveminrate : 1
      maxRate = !isEmpty(baselineSetting.liveminrate) ? baselineSetting.livemaxrate : 1
    }
  }

  const team = getMarketDetail(originSportslist, item.Name);
  if (isEmpty(team)) return "";
  return (
    <li className={`col team_l sport_more_list_anim ${checkBetted(item) ? "active" : ""} ${!interiorShowMarket && "sport_more_list_anim_none"} ${(item.Price[0].Price > nowRate) && "rate_up_effect "} ${(item.Price[0].Price < nowRate) && " rate_down_effect "}`}
      key={itemIndex} onClick={() => onBetItem(item, betList, itemIndex)} >
      <div className="team_l">{team}{!isEmpty(item.Line) ? `(${item.Line})` : ""}</div>
      <span className="team_r font07">&nbsp;{fixedNumber(Number(item.Price[0].Price))}</span>
      {
        (
          (item.Price[0].status > 3) ||
          (item.Status == 10) ||
          (!isEmpty(rateValue) &&
            ((item.Price[0].Price > rateValue.max) || (item.Price[0].Price < rateValue.min))
          ) ||
          (fixedNumber(item.Price[0].Price) < minRate) ||
          ((
            (pageInfo.gameType === "live") &&
            (fixedNumber(item.Price[0].Price) > maxRate)
          )) ||
          (fixedNumber(item.Price[0].Price) == 1)
        ) &&
        <div className="betting-block" style={{ display: "flex" }}>
          <div className="lock">
            <span className="icon-lock"></span>
          </div>
        </div>
      }
    </li>
  );
};

const mapStateToProps = state => ({
  baselineSetting: state.sports.baselineSetting,
  pageInfo: state.page.pageInfo
})

export default connect(mapStateToProps)(BetItem);




// WEBPACK FOOTER //
// ./src/components/sports/BetItem.js